import { render, staticRenderFns } from "./Add3.vue?vue&type=template&id=13bdcae6&scoped=true&"
import script from "./Add3.vue?vue&type=script&lang=js&"
export * from "./Add3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdcae6",
  null
  
)

export default component.exports